import { render, staticRenderFns } from "./demand-disapproved.vue?vue&type=template&id=19c31d16&scoped=true&"
import script from "./demand-disapproved.vue?vue&type=script&lang=js&"
export * from "./demand-disapproved.vue?vue&type=script&lang=js&"
import style0 from "./demand-disapproved.vue?vue&type=style&index=0&id=19c31d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c31d16",
  null
  
)

export default component.exports